/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Maybe } from 'bundles/xddp/__generated__/baseContentfulTypes';
import type { MarketingContentFieldsFragment } from 'bundles/xddp/__generated__/contentfulTypes';
import InformationCard from 'bundles/xddp/components/shared/InformationCard';
import type { UserAgentProps } from 'bundles/xddp/types';

const styles = {
  root: css`
    padding: 36px 0;
  `,
};

type Props = UserAgentProps & {
  marketingContent?: Maybe<MarketingContentFieldsFragment>;
};

const GetStartedSection = ({ marketingContent, userAgent }: Props) => {
  if (!marketingContent) {
    return null;
  }

  return (
    <div css={styles.root} className="section-highlighted" data-testid="get-started-section">
      <InformationCard userAgent={userAgent} marketingContent={marketingContent} />
    </div>
  );
};

export default GetStartedSection;
